import { CARD_ELEMENT_TYPE } from '../../../cards/constants';

export const getCardPhotoElementsWithConfigurationFromAccountCard = ({
  accountCard,
}) => {
  if (!accountCard) {
    return [];
  }

  const accountCardSide = accountCard.account_card_sides?.[0];
  const cardSide = accountCardSide?.card_side;

  const photoCardElements = (
    cardSide?.card_template?.card_elements ?? []
  ).filter(element => element.type === CARD_ELEMENT_TYPE.PHOTO);

  return photoCardElements.map(elem => ({
    cardElement: elem,
    cardElementConfiguration:
      (accountCardSide?.card_element_configurations ?? []).find(
        config => config.card_element.id === elem.id,
      ) ??
      (cardSide?.card_element_configurations ?? []).find(
        config => config.card_element.id === elem.id,
      ),
  }));
};
